<template>
  <ul class="form-item-list">
    <li><h3>현재 운전을 하고 있습니까?</h3></li>
    <li class="text-center">
      <el-checkbox
        class="round"
        label="예"
        border
        v-model="yes"
        :error="formData.answer.error"
        @change="event => updateChecked(event, 'yes')"
      />
      <el-checkbox
        class="round"
        label="아니오"
        border
        v-model="no"
        :error="formData.answer.error"
        @change="event => updateChecked(event, 'no')"
      />
    </li>
    <li v-if="yes">
      <div
        class="detail-form"
        v-for="(detail, index) in details"
        :key="index"
      >
        <el-row>
          <element-select
            v-model="detail['차종'].value"
            :error="detail['차종'].error"
            :label="detail['차종'].label"
            :items="detail['차종'].items"
            :placeholder="detail['차종'].placeholder"
            @input="(value) => changeDetail(value, index)"
          />
        </el-row>
      </div>

      <el-button
        icon="el-icon-plus"
        class="add-detail-btn"
        @click="addCarDetail"
      >
        차종(용도) 추가
      </el-button>
    </li>
    <li class="annotation" v-if="yes">
      <p>※ 둘 이상의 차량을 운전하거나 하나의 차량을 둘 이상의 목적으로 사용하는 경우 해당되는 사항을 모두 기재하십시오.</p>
    </li>
  </ul>
</template>
<script>
import { Checkbox, Row, Col } from 'element-ui';

export default {
  name: 'Drive',
  props: ['formData'],
  components: {
    [Checkbox.name]: Checkbox,
    [Row.name]: Row,
    [Col.name]: Col,
  },
  data() {
    return {
      yes: this.formData.answer.value === '예',
      no: this.formData.answer.value === '아니오',
      details: [
        {
          '차종': {
            label: "차종",
            value: "",
            error: "",
            placeholder: '차종(용도)을 선택해주세요',
            validations: [
              { type: "required", message: "필수항목입니다" }
            ],
            items: [
              { value: "승용차", label: "승용차", description: "승용차는 승차 정원이 10인 이하인 차량입니다." },
              { value: "승합차", label: "승합차", description: "승합차는 승차 정원이 11인 이상인 차량입니다." },
              { value: "화물차", label: "화물차", description: "화물차는 적재함이 있는 차량입니다." }
            ]
          }
        },
      ]
    }
  },
  mounted() {
    this.$emit('update', { type: '차종', value: '' });
  },
  methods: {
    updateChecked(event, type) {
      const reverse = type === 'yes' ? 'no' : 'yes';
      this.$data[reverse] = !event;
      this.$emit('update', { type: 'answer', value: type });
    },
    changeDetail(value, index) {
      this.details[index]['차종'].value = value;
      this.$emit('update', { type: 'detail', value: this.details });
    },
    addCarDetail() {
      const data = this.details;
      const firstData = this.details[0];
      let detail = {};
      Object.keys(firstData).map(key => {
        detail[key] = {
          ...firstData[key],
          value: ''
        }
      });

      this.details = Array.prototype.concat.call(data, [detail]);
    }
  }
}
</script>

<style lang="scss" scoped>
.form-item-list {
  li {
    &.text-center {
      text-align: center;
    }
    h3 {
      font-size: 18px !important;
    }
    p {
      span.blue {
        color: #174BE6;
      }
    }
    .el-checkbox {
      &.round {
        width: 40%;
        text-align: left;

        .el-checkbox__inner {
          border-radius: 50% !important;
        }
      }
    }
  }
}
</style>